<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <button
        class="ac-close-button"
        @click="toggleActionModal(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
      <div class="ac-header">
        Technician Information
      </div>
    </div>
    <div class="ac-body-container">
      <form
        class="ac-image-upload-form"
        enctype="multipart/form-data"
      >
        <div
          v-if="loading"
          class="ac-avatar-loading-container"
        >
          <img
            src="@shared/assets/img/general/loading.svg"
            alt="Loading"
          >
        </div>
        <img
          v-else-if="imagePreview"
          :src="imagePreview"
          alt="Avatar Preview"
          class="image-preview"
        >
        <img
          v-else-if="avatarUri"
          :src="avatarUri"
          alt="Avatar"
          :class="['image-preview', selectedTech.pendingProfileChanges && selectedTech.pendingProfileChanges.approvalPending ? 'pending' : '']"
        >
        <img
          v-else
          src="@shared/assets/img/tech/profile.png"
          alt="tech-illustration"
          class="tech-illustration"
        >
        <div
          v-if="!loading && selectedTech.pendingProfileChanges && selectedTech.pendingProfileChanges.approvalPending"
          class="ac-image-pending-container"
        >
          <img
            src="@shared/assets/img/technician/pending.svg"
            alt="Edit"
            class="edit-icon"
          />
        </div>
        <div
          v-else-if="!loading"
          class="ac-image-edit-container"
        >
          <img
            src="@shared/assets/img/general/pencil-black.png"
            alt="Edit"
            class="edit-icon"
          >
        </div>
        <input
          v-if="!loading && !(selectedTech.pendingProfileChanges && selectedTech.pendingProfileChanges.approvalPending)"
          id="file-input"
          ref="imageRef"
          type="file"
          class="db-input"
          accept="image/*"
          @change="selectedImage"
        >
        <div
          v-if="!loading && !(selectedTech.pendingProfileChanges && selectedTech.pendingProfileChanges.approvalPending)"
          class="ac-image-edit-text"
        >
          Add Photo
        </div>
      </form>
      <ProfileApproval
        v-if="selectedTech.pendingProfileChanges && selectedTech.pendingProfileChanges.approvalPending"
      />
      <div class="row-container">
        <div class="invite-name-input-container">
          <div class="invite-input-label-container">
            <span class="invite-input-label-txt">Tech First Name:</span>
          </div>
          <SACInput
            placeholder="First Name"
            field="firstName"
            :value="tech.firstName"
            :change="change"
            :error="error.firstName"
          />
        </div>
        <div class="invite-name-input-container">
          <div class="invite-input-label-container">
            <span class="invite-input-label-txt">Tech Last Name:</span>
          </div>
          <SACInput
            placeholder="Last Name"
            field="lastName"
            :value="tech.lastName"
            :change="change"
            :error="error.lastName"
          />
        </div>
      </div>
      <div class="invite-input-container">
        <div class="invite-input-label-container">
          <span class="invite-input-label-txt"> Email </span>
        </div>
        <SACInput
          placeholder="Email"
          field="email"
          :value="tech.email"
          :change="change"
          :error="error.email"
        />
      </div>
      <div class="invite-input-container">
        <div class="invite-input-label-container">
          <span class="invite-input-label-txt"> Phone </span>
        </div>
        <SACInput
          placeholder="Phone"
          field="phone"
          :value="tech.phone"
          :change="change"
          :error="error.phone"
          type="number"
          restrict="phone-number"
        />
      </div>
      <div class="invite-input-container">
        <div class="invite-input-label-container">
          <span class="invite-input-label-txt"> Partner </span>
        </div>
        <SACDropdown
          :showSearch="true"
          placeholder="Select partner"
          field="corporationId"
          :value="tech.corporationId"
          :options="partnerOptions"
          :change="change"
          :error="error.partner"
        />
      </div>
      <div class="invite-input-container">
        <SACCheckbox
          label="Non-Installer (exclude from installation reporting)"
          :checked="tech.nonInstaller"
          field="nonInstaller"
          :change="(field) => change(field, !tech.nonInstaller)"
        />
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        class="ac-form-button"
        @click="toggleActionModal(false)"
      >
        Cancel
      </button>
      <button
        class="ac-form-button"
        @click="updateTech"
      >
        Save
      </button>
    </div>
    <ProcessOverlay :show="processing" />
  </div>
</template>

<script>
import technicianMixin from '@shared/mixins/technicianMixin';

import SACInput from '@shared/components/sac/SACInput.vue';
import SACDropdown from '@shared/components/sac/SACDropdown.vue';
import SACCheckbox from '@shared/components/sac/SACCheckbox.vue';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

import formatPhoneNumber from '@shared/lib/formatter/formatPhoneNumber';
import emailValidation from '@shared/lib/errorCatch/emailValidation';
import phoneValidation from '@shared/lib/errorCatch/phoneValidation';
import ProfileApproval from '@shared/components/technician/ProfileApproval.vue';

export default {
  name: 'EditTechInfo',
  components: {
    SACInput,
    SACDropdown,
    SACCheckbox,
    ProcessOverlay,
    ProfileApproval,
  },
  mixins: [technicianMixin],
  data() {
    return {
      imagePreview: '',
      avatarUri: null,
      error: {},
      processing: false,
      loading: false,
      tech: {},
    };
  },
  computed: {
    avatarUrl() {
      if (this.selectedTech.pendingProfileChanges?.profileUrl) {
        return this.selectedTech.pendingProfileChanges.profileUrl;
      }
      if (this.selectedTech.profileUrl) {
        return this.selectedTech.profileUrl;
      }
      return '';
    },
  },
  watch: {
    avatarUrl() {
      this.getAvatarImg();
    },
  },
  mounted() {
    if (this.selectedTech.profileUrl) {
      this.getAvatarImg();
    }
    if (this.selectedTech) {
      this.tech = this.selectedTech;
    }
  },
  methods: {
    change(field, value) {
      let v = value;
      if (field === 'phone') {
        v = formatPhoneNumber(value);
      }
      this.tech = {
        ...this.tech,
        [field]: v,
      };
    },
    selectedImage() {
      const image = this.$refs.imageRef.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (e) => {
        this.imagePreview = e.target.result;
      };
      const payload = {
        image,
      };
      this.selectImage(payload);
    },
    async updateTech() {
      const {
        id: adminId,
        corporationId,
      } = this.currentAdmin;
      const {
        id,
        firstName,
        lastName,
        email,
        phone,
        corporationId: selectedCorpId,
        nonInstaller,
        createPassword,
        hasLoggedIn,
      } = this.tech;
      const errObj = {};
      if (!firstName && (firstName && !firstName.trim())) {
        errObj.firstName = 'Please enter the tech\'s first name';
      }
      if (!lastName && (lastName && !lastName.trim())) {
        errObj.lastName = 'Please enter the tech\'s last name';
      }
      if (!email && (email && !email.trim())) {
        errObj.email = 'Please enter the tech\'s email';
      } else if (!emailValidation(email)) {
        errObj.email = 'Email is not valid';
      }
      if (!phone && (phone && !phone.trim())) {
        errObj.phone = 'Please enter the tech\'s phone number';
      } else if (!phoneValidation(phone)) {
        errObj.phone = 'Phone number is not valid';
      }
      this.error = errObj;
      if (Object.keys(this.error).length === 0) {
        const tech = {
          firstName,
          lastName,
          email,
          phone,
          corporationId: selectedCorpId || corporationId,
          adminId,
          nonInstaller,
          createPassword,
          hasLoggedIn,
          id,
        };
        this.processing = true;
        await this.$store.dispatch('updateTechnician', { updateTech: tech });
        this.toggleActionModal(false);
        this.processing = false;
      }
    },
    async getAvatarImg() {
      this.loading = true;
      try {
        this.avatarUri = await this.$store.dispatch('getImageResponse', {
          url: this.avatarUrl,
        });
      } catch (err) {
        console.error(err);
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>

.ac-image-upload-form {
  position: relative;
  display: flex;
  align-items: flex-end;
  margin-bottom: 28px;

  .ac-image-edit-text {
    font-size: 1.125rem;
    color: $BLACK;
    font-weight: 600;
    margin-left: -8px;
  }

  #file-input {
    cursor: pointer;
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 180px;
    height: 180px;
  }

  .ac-avatar-loading-container {
    width: 180px;
    height: 180px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
  }

  .tech-illustration {
    width: 180px;
    height: 180px;
    object-fit: contain;
  }

  .image-preview {
    width: 180px;
    height: 180px;
    border-radius: 50%;
    object-fit: cover;
    &.pending {
      filter: brightness(70%);
    }
  }
  .ac-image-pending-container {
    position: absolute;
    bottom: 0;
    left: 120px;
    width: 36px;
    height: 36px;
    padding: 2px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    .edit-icon {
      width: 100%;
    }
  }
  .ac-image-edit-container {
    position: absolute;
    bottom: 0;
    left: 120px;
    width: 36px;
    height: 36px;
    padding: 2px;
    border-radius: 4px;
    background-color: $NBLUE100;
    display: flex;
    align-items: center;
    justify-content: center;
    .edit-icon {
      width: 100%;
    }
  }
}

.row-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
}

.invite-name-input-container {
  width: 50%;

  &:nth-child(2) {
    margin-left: 15px;
  }
}

.invite-input-container {
  margin-bottom: 20px;

  .invite-input-label-container {
    margin-bottom: 15px;
  }

  .invite-input-label-txt {
    font-size: 18px;
    font-weight: 500;
  }
}
</style>
